export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["NONE"] = 0] = "NONE";
})(LogLevel || (LogLevel = {}));
export var setLogLevel = function (level) {
    switch (level) {
        case LogLevel.NONE:
            console.log = function () { };
            console.error = function () { };
            console.warn = function () { };
            console.info = function () { };
            console.debug = function () { };
            console.trace = function () { };
            console.groupCollapsed = function () { };
            console.groupEnd = function () { };
            console.group = function () { };
            break;
        default:
            break;
    }
};
